__turbopack_context__.v({
  "loaderContainer": "ProspectsSection-module__l0TDBG__loaderContainer",
  "pagination": "ProspectsSection-module__l0TDBG__pagination",
});
